export const PHYSICAL_DATA_LOADING = 'PHYSICAL_DATA_LOADING';
export const PHYSICAL_DATA_LIST = 'PHYSICAL_DATA_LIST';
export const PHYSICAL_DATA_ERROR = 'PHYSICAL_DATA_ERROR';
export const PRINT_PHYSICAL_LOADING = 'PRINT_PHYSICAL_LOADING';
export const PRINT_PHYSICAL_ERROR = 'PRINT_PHYSICAL_ERROR';
export const CLEAR_PHYSICAL_ERROR = 'CLEAR_PHYSICAL_ERROR';
export const PHYSICAL_CLEAR_GRID_DATA = 'PHYSICAL_CLEAR_GRID_DATA';
export const PHYSICAL_DATA_DELETE = 'PHYSICAL_DATA_DELETE';
export const PHYSICAL_DATA_DELETE_ERROR = 'PHYSICAL_DATA_DELETE_ERROR';
export const CLEAR_PHYSICAL_LIST_ERROR = 'CLEAR_PHYSICAL_LIST_ERROR';
export const SET_TO_DATE_MIN = 'SET_TO_DATE_MIN';
export const SET_FROM_DATE_MAX = 'SET_FROM_DATE_MAX';
export const SET_PRINT_DATA = 'SET_PRINT_DATA';



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/physical/state/PhysicalList/types.js